module.exports = __webpack_public_path__ + "static/media/fathersday.760fc478.jpeg";